<template>
  <div ref="app">
    <component :is="layout"> </component>
    <bindingphonenumber :visible.sync="bindingphoneisVisible" v-if="bindingphoneisVisible"></bindingphonenumber>
  </div>
</template>

<script>
  import bindingphonenumber from "@/components/User/Bindingphonenumber.vue";
  import {
    GetThemeData
  } from "@/api/Theme.js";
  import {
    mapActions
  } from "vuex";
  import _ from 'lodash'
  export default {
    name: "App",
    data() {
      return {
        ThemeName: "",
      };
    },
    components: {
      bindingphonenumber,
    },
    watch: {
      "$store.getters.Verifyphonenumber": {
        handler: function (newVal, oldVal) {
          if (newVal == "true") {
            this.bindingphoneisVisible = true;
          } else {
            this.bindingphoneisVisible = false;
          }
        },
      },
      "$store.getters.sitestyle": {
        handler: function (newVal, oldVal) {
          var oCss = document.getElementById("theme");
          switch (newVal) {
            case "default":
              oCss.href = "static/theme/default/index.css";
              break;
            case "gray":
              oCss.href = "static/theme/gray/gray.css";
              break;
            case "red":
              oCss.href = "static/theme/red/red.css";
              break;
            default:
              oCss.href = "static/theme/default/index.css";
              break;
          }
        },
      },
    },

    created() {
      // this. rezhuye();
      this.bindingphoneisVisible = this.$store.getters.Verifyphonenumber == "true" ? true : false;
      this.ThemeName = this.$store.getters.sitestyle;
      this.getsitestyle();
      this.GetData();
    },
    provide() {
      return {
        reload: this.reload,
      };
    },
    computed: {
      layout() {
        if (this.$route.meta.layout) {
          return this.$route.meta.layout + "-layout";
        } else {
          if (this.$route.meta) {
            return this.default_layout + "-layout";
          }
        }
      },
    },
    mounted() {

      //连接singnalr
      this.aInitConnection();

      this.$nextTick(() => {
        const $app = this.$refs.app
        const standardScale = 1080 / 1920;

        window.addEventListener(
          'resize',
          _.debounce(function () {
            const docHeight = document.body.clientHeight;
            const docWidth = document.body.clientWidth;
            // debugger;
            if (docWidth < 800) {
              const currentScale = docHeight / docWidth;
              let [scale, translate] = [0, 0];
              // 以宽度计算
              scale = docWidth / 1920;
              const shouleHeight = 1080 * scale;
              const offsetHeight = docHeight - shouleHeight;
              translate = offsetHeight > 0 ? `translate(0, ${offsetHeight / 2}px)` : '';
              //
              $app.style.cssText = `
                transform: scale(${scale});
                transform-origin: top left;
                min-width: 1880px;
                width: 100%;
                min-height: "680px";
                height: 100%;
              `
            } else {
              // min-width: 1920px;
              $app.style.cssText = `
                overflow: auto;
                min-width: 1880px;
                width: 100%;
                margin: 0 auto;
                min-height: "680px";
                height: 100%;
              `
            }
          })
        )

        if (document.createEvent) {
          var event = document.createEvent('HTMLEvents')
          event.initEvent('resize', true, true)
          window.dispatchEvent(event)
        } else if (document.createEventObject) {
          window.fireEvent('onresize')
        }
      })

    },
    methods: {

      // rezhuye()
      // {
      //   debugger
      //   const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      //   if(isMobile)
      //   {
      //      //是移动设备的话打开移动端发布路径
      //      //window.location = "https://www.coalgeocloud.com/mobileWeb/Index2_h5";
      //      window.location = "https://www.coalgeocloud.com/wechatoa";
      //   }
      // },
      //通过声明reload方法，控制router-view的显示或隐藏，从而控制页面的再次加载
      ...mapActions({
        aInitConnection: "message/aInitConnection"
      }),
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true;
        });
      },
      getsitestyle() {
        var oCss = document.getElementById("theme");
        if (this.ThemeName != "") {
          switch (this.ThemeName) {
            case "default":
              oCss.href = "static/theme/default/index.css";
              break;
            case "gray":
              oCss.href = "static/theme/gray/gray.css";
              break;
            case "red":
              oCss.href = "static/theme/red/red.css";
              break;
            default:
              oCss.href = "static/theme/default/index.css";
              break;
          }
        }
      },
      GetData() {
        GetThemeData().then((res) => {
          if (res.Code == 200) {
            if (res.Data.ThemeName != "") {
              this.ThemeName = res.Data.ThemeName;
              this.$store.commit("theme/mSetsitestyle", this.ThemeName);
              this.getsitestyle();
            }
          } else {
            this.ThemeName = "";
          }
        });
      },
    },
    data() {
      return {
        default_layout: "default", //设置layout
        isRouterAlive: true,
        bindingphoneisVisible: false,
      };
    },
  };

</script>

<style lang="scss">
  body {
    margin: 0;
    padding: 0;
  }

  .content {
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue